var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIraq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C11.4007 0 4.06988 5.4275 1.24402 13.0435H38.7561C35.9302 5.4275 28.5993 0 20 0V0Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C28.5993 39.9999 35.9302 34.5724 38.7561 26.9564H1.24402C4.06988 34.5724 11.4007 39.9999 20 39.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2174 18.6956C15.2064 18.6956 15.1957 18.6963 15.1848 18.6965V18.6956H11.3616C11.5554 17.9467 12.2349 17.3913 13.0435 17.3913V14.7826C10.646 14.7826 8.69564 16.7331 8.69564 19.1304V21.2609V21.3044H15.1848H15.2174C15.4571 21.3044 15.6521 21.4995 15.6521 21.7392V22.6087H6.95642V25.2174H18.2608V21.7391C18.2608 20.061 16.8955 18.6956 15.2174 18.6956V18.6956Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.739 22.6087V14.7826H19.1304V25.2174H23.4782V22.6087H21.739Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4347 22.6088V14.7826H27.8261V22.6088H26.9565V20.0001H24.3478V25.2175H32.1739V22.6088H30.4347Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraq);
export default __webpack_public_path__ + "static/media/iraq.d2b6ad1138192963b53016973b3e0e45.svg";
export { ForwardRef as ReactComponent };